import React from "react"
import { graphql } from "gatsby"
import { ArticlePdfFieldsFragment } from "../../../../../../graphql-types"
import * as styles from "./pdf.module.scss"
import { useLocale } from "../../../../../context/locale-context"
import StructuredTextContent from "../structured-text-content/structured-text-content"

type ArticlePDFProps = { data: ArticlePdfFieldsFragment }

const ArticlePDF: React.FC<ArticlePDFProps> = ({
  data: { pdf, title, structuredText, downloadInput, backgroundColor, textColor },
}) => {
  const { locale } = useLocale()

  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: backgroundColor?.hex ?? "#D9C5F8",
        color: textColor?.hex ?? "#162B44",
      }}
    >
      <div className={styles.articleStructuredText}>
        <h2 className={styles.title}>{title}</h2>
        {structuredText.value && <StructuredTextContent data={structuredText.value} isNotRichContent={true}/>}
        <a className={styles.button} target="_blank" href={pdf.url}>
          <div className={styles.downloadInput}>
          {downloadInput || (locale === "fr" ? "Télécharger" : "Download")}
          </div>
        </a>
      </div>
    </div>
  )
}

export const fragment = graphql`
  fragment ArticlePdfFields on DatoCmsArticlePdf {
    __typename
    id
    pdf {
      url
    }
    title
    structuredText {
      value
    }
    downloadInput
    backgroundColor {
      hex
    }
    textColor {
      hex
    }
  }
`

export default ArticlePDF
